import React from "react"
//import * as styles from "./BackgroundVideo.module.scss"

export type BackgroundVideoProps = React.DetailedHTMLProps<
  React.VideoHTMLAttributes<HTMLVideoElement>,
  HTMLVideoElement
>

const BackgroundVideo: React.FC<BackgroundVideoProps> = props => {
  //console.log('Rendering BackgroundVideo', props)
  return (
    <video
      {...props}
      muted
      playsInline
      autoPlay
      loop
      style={{ objectFit: "cover", position: "absolute", width: "100%", height: "100%", top: 0, left: 0 }}
    />
  )
}

export default BackgroundVideo
